import BaseComponent from './BaseComponent';

import {
	VictoryLine, VictoryChart, VictoryAxis,
	VictoryLegend, VictoryTheme, VictoryTooltip
} from 'victory';

class LinesChart extends BaseComponent {

	dataSanitize(data, labels){
		return data.map(chartLine => {
			return this.sanitizeLine(chartLine, labels)
		})

	}

	sanitizeLine(lineData, labels){
		let newLineData = []
		let sumY = 0
		for(const lab of labels){
			if(!lineData.find(elem => String(elem.xaxis) === lab)){
				newLineData.push({
					xaxis: lab,
					yaxis:sumY,
					label: ""
				})

			}else{
				newLineData.push(JSON.parse(JSON.stringify(
					lineData.find(elem => String(elem.xaxis) === String(lab))
				)))

				sumY+= newLineData[newLineData.length-1].yaxis
				newLineData[newLineData.length-1].yaxis=sumY
			}
		}
		return newLineData
	}

	render() {

		const colors = 
			[
				'#547C87', //(Azul verdoso)
				'#8E6B8B', //(Púrpura)
				'#9FB1B5', //(Gris azulado)
				'#C8AD7F', //(Beige)
				'#DAA520', //(Oro viejo)
				'#C0C0C0', //(Plata)
				'#CD853F', //(Bronce)
				'#D2B48C', //(Amarillo claro)
				'#4682B4', //(Azul acero)
				'#FFD700', //(Amarillo oro)
				'#808000', //(Amarillo oliva)
				'#A0522D', //(Marrón)
				'#800080', //(Púrpura)
				'#4B0082', //(Índigo)
				'#6B8E23', //(Verde oliva)
			]
			
		return (

			this.props.labels?.length > 1?
			<>
			
			<VictoryChart
					domainPadding={20}
					height={this.props.height??400}
					width={this.props.width??600}
					theme={VictoryTheme.material}
					padding={{ top: 10, bottom: 30, left:60 }}
				>

					<VictoryAxis
						tickValues={this.dataSanitize(this.props.data, this.props.labels)?.map((bar,idx) => {
							return idx+1
						})}
						style={{tickLabels: {
							
							fontFamily: "inherit",
							fontSize: 9
						}}}
						fixLabelOverlap={true}
						tickFormat={this.props.labels?this.props.labels:[]}
					/>
					<VictoryAxis
						dependentAxis
						tickFormat={(x) => (`$${x / 1000}k`)}
					/>
					
					{this.dataSanitize(this.props.data, this.props.labels)?.map((barPiece,count) => {
						return <VictoryLine key={'stackline_'+count}
							labelComponent={<VictoryTooltip />}
							data={barPiece}
							x="xaxis"
							y="yaxis"
							style={{ data: {stroke: (p) => colors[count]} }}
						/>
					})}	
				</VictoryChart>

				<VictoryLegend x={20} y={0} height={20}
					orientation="horizontal"
					gutter={20}
					//style={{ border: { stroke: "black" }, title: {fontSize: 20 } }}
					style={{ labels: {fontSize: 9 } }}
					data={this.props.data?.map((lineChart,count) => {
						let name = lineChart.find(elem => {
							return String(elem.label) !== ''?String(elem.label):false
						})
						name = name.label.split(' ').slice(1).join(' ')
						return { name: name, symbol: { fill: colors[count] } }
					})?.slice(0,4)??[]}
				/>

				{this.props.data?.length>4?
				<VictoryLegend x={20} y={0} height={20}
					orientation="horizontal"
					gutter={20}
					style={{ labels: {fontSize: 9 } }}
					data={this.props.data?.map((lineChart,count) => {
						let name = lineChart.find(elem => {
							return String(elem.label) !== ''?String(elem.label):false
						})
						name = name.label.split(' ').slice(1).join(' ')
						return { name: name, symbol: { fill: colors[count+4] } }
					})?.slice(4,8)??[]}
				/>:undefined}
				{this.props.data?.length>8?
				<VictoryLegend x={20} y={0} height={20}
					orientation="horizontal"
					gutter={20}
					style={{ labels: {fontSize: 9 } }}
					data={this.props.data?.map((lineChart,count) => {
						let name = lineChart.find(elem => {
							return String(elem.label) !== ''?String(elem.label):false
						})
						name = name.label.split(' ').slice(1).join(' ')
						return { name: name, symbol: { fill: colors[count+8] } }
					})?.slice(8,12)??[]}
				/>:undefined}
				<div style={{paddingBottom:'50px'}}></div>
			</>
			:
			<>
				<h4 className="mt-3 ml-3 font-weight-light" style={{paddingBottom:'50px'}}>Para poder ver este gráfico debe seleccionar datos de al menos dos meses</h4>
			</>
		)
	}

}

export default LinesChart;
